import { createSelector } from '@ngrx/store';
import { selectFilterState } from '../filter.selectors';
import { FilterState } from '@immosky/types';

export const selectContractTypeFilterState = createSelector(
  selectFilterState,
  (state: FilterState) => state.contractType
);
